module.exports = __webpack_public_path__ + "static/media/question_orange.988a0987.svg";